import React from 'react';
import { FlexBox } from '../../../global/FlexBox';
import UsersDrawer from '../UsersDrawer';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { useNavigate } from 'react-router-dom';
import { useUserManagementContext } from '../../context/UserManagementContext';

export const SuccessDrawer = ({
  isOpen,
  handleDrawerClose,
}: {
  isOpen: boolean;
  handleDrawerClose: () => void;
}) => {
  const { currentUserData } = useUserManagementContext();
  const navigate = useNavigate();

  const handleViewUser = () => {
    navigate(`users/${currentUserData?.id}`, { replace: true });
    handleDrawerClose();
  };

  const handleBackToUsers = () => {
    navigate(`users`, { replace: true });
    handleDrawerClose();
  };
  return (
    <UsersDrawer
      id="success-drawer"
      isOpen={isOpen}
      handleDrawerClose={handleDrawerClose}
    >
      <FlexBox
        direction="column"
        alignItems="center"
        justifyContent="center"
        height="100%"
        sx={{ gridRowGap: 24 }}
      >
        <CheckCircleOutlineIcon style={{ fontSize: 88, color: '#4CAF50' }} />
        <FlexBox
          direction="column"
          alignItems="center"
          justifyContent="center"
          sx={{ gridRowGap: 16 }}
        >
          <Typography variant="h3">User Created</Typography>

          <Typography variant="body1" color="textPrimary">
            {currentUserData?.username} has been successfully created.
          </Typography>
        </FlexBox>
        <FlexBox sx={{ gridColumnGap: 24 }}>
          <Button variant="outlined" color="primary" onClick={handleViewUser}>
            View User
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleBackToUsers}
          >
            Back to Users
          </Button>
        </FlexBox>
      </FlexBox>
    </UsersDrawer>
  );
};
